export default {
      id: "ic_instagram-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#ic_instagram-usage",
      toString: function () {
        return this.url;
      }
    }